<template>
  <div style="width:100%;">
    <div style="position: fixed;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">
          办理
        </van-button>
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
      </div>

      <div class="doTask" v-if="isshow">
        <div>
          <van-field name="radio" label="审批意见">
            <template #input>
              <van-radio-group v-model="auditForm.status" direction="horizontal">
                <van-radio name="同意">同意</van-radio>
                <van-radio name="不同意">不同意</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
        <div>
          <van-cell-group>
            <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea"
                       placeholder="请输入审批说明"/>
          </van-cell-group>
        </div>
        <div style="text-align:center">
          <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交</van-button>
        </div>
      </div>
    </div>

    <van-collapse v-model="activeNames" style="margin-top: 60px;">
      <van-collapse-item title="意向单信息" name="1">
        <van-field v-model="inputForm.projectName" label="项目名称" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.code" label="意向单编号" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.unitPrice" label="租金标准" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.amount" label="租赁价格" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.inTime" label="计划进场时间" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.user.name" label="招商人员" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.frontMoney" label="意向金" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.lessorId" label="出租方" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.payTime" label="计划缴费时间" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.signingTime" label="计划签约时间" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.customerName" label="客户" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.bcategoryId" label="经营业态" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.brand" label="经营品牌" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.remark" label="备注" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field label="租赁资源" label-width="100px" readonly>
          <template #button>
            <van-button plain type="default" @click="view">查看租赁资源</van-button>
          </template>
        </van-field>
        <div style="padding-left: 16px;" v-show="inputForm.attachList.length > 0">
          <p>附件</p>
          <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.attachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
        </div>
      </van-collapse-item>
    </van-collapse>
    <process-record :procInsId="procInsId"></process-record>
  </div>
</template>

<script>
import TaskService from '@/api/flowable/TaskService.js'
import ProcessService from '@/api/flowable/ProcessService'
import LeaseService from "@/api/contract/LeaseService";
import processRecord from "../../../components/processRecord/processRecord";

export default {
  data() {
    return {
      activeNames: ['1', '2'],
      isshow: false,
      radio: '',
      inputForm: {
        id:'',
        projectId:'',
        houseId: '',
        code: '',
        type: '',
        location: '',
        propertyId: '',
        inPropertyArea:null,
        propertyArea: null,
        residuePropertyArea:null,
        lastPropertyArea:null,
        coefficient:1,
        isEnabled: '1',
        isLeaseback: '0',
        remark: '',
        unitPrices:[],
        attachList:[],
        attachIds:[],
        isDoTask: false,
        isLastTask: false
      },
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      businessId: '',
      type: ''
    }
  },
  components: {
    processRecord
  },
  mounted() {
  },
  created() {
    let query = this.$route.query;
    this.businessId = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    // let id = this.$cookie.get('id')
    // this.taskId = this.$cookie.get('taskId')
    // this.taskDefKey = this.$cookie.get('taskDefKey')
    // this.procInsId = this.$cookie.get('procInsId')
    // this.procDefId = this.$cookie.get('procDefId')
    this.init(this.businessId)
    // this.init('1686650695096860674')

  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },
    init(id) {
      new LeaseService().queryById(id).then(({data}) => {
        this.inputForm = data
        this.inputForm.leasingResources.forEach((i)=>{
          i.coin=i.benchmarkUnitPrice
          i.area=i.lastPropertyArea
        })
      }).catch(e => {
        console.log(e)
      })
    },
    view() {
      this.$router.push({
        path: 'shye_lease_detail',
        query: {
          data: this.inputForm.leasingResources
        }
      })
    },
    close() {
      if (this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    submitTask() {
      if (this.auditForm.status == '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        vars = {...vars, ..._this.inputForm}
        _this.auditForm.message = _this.inputForm.remarks

        _this.auditForm.type = _this.inputForm.isLastTask ? '_flow_approval' : '_flow_agree'

        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          businessTable: 'shye_finance_receivable_adjust',
          businessId: this.businessId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({data}) => {
          // if(data.code === 200) {
            _this.$toast.clear();
            _this.$toast.success('提交成功');
            //更新数据库状态
            _this.inputForm.flowType = _this.inputForm.isLastTask ? 4 : 2;
            new LeaseService().startFlow(_this.inputForm);

            setTimeout(function () {
              _this.close()
            }, 800)
          // } else {
          //   _this.$toast.clear();
          //   _this.$toast.fail(data.msg);
          //   setTimeout(function () {
          //     _this.close()
          //   }, 800)
          // }
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({data}) => {
          // if(data.code === 200) {
            _this.$toast.clear();
            _this.$toast.success('提交成功');
            //更新数据库状态
            _this.inputForm.flowType = 3;
            new LeaseService().startFlow(_this.inputForm);

            setTimeout(function () {
              _this.close()
            }, 800)
          // } else {
          //   _this.$toast.clear();
          //   _this.$toast.fail(data.msg);
          //   setTimeout(function () {
          //     _this.close()
          //   }, 800)
          // }
        })
      }).catch(() => {
      })
    }
  }
}
</script>
